// extracted by mini-css-extract-plugin
export default {"main_house":"House_main_house__i4FRq","house":"House_house__ZEElI","building_structure":"House_building_structure__J1eri","margine":"House_margine__HYguw"};